// ===========================================
// MONEY — every amount keeps its own currency
// ===========================================
// The dashboard mirror of the API's fx formatting: $1,240 · €1,240 · 8.450 kr
// (Danish keeps its dot-thousands and trailing kr). Amounts never cross a
// currency line here — conversion happens server-side at a dated ECB rate and
// arrives already labeled.

const STYLES: Record<string, { pre?: string; post?: string; locale: string }> = {
  USD: { pre: '$', locale: 'en-US' },
  EUR: { pre: '€', locale: 'en-IE' },
  DKK: { post: ' kr', locale: 'da-DK' },
};

export function formatMoney(cents: number | null | undefined, currency: string = 'USD', opts?: { exact?: boolean }): string {
  if (cents == null) return '—';
  const c = String(currency || 'USD').toUpperCase();
  const s = STYLES[c];
  const digits = opts?.exact ? 2 : 0;
  const n = new Intl.NumberFormat(s?.locale || 'en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits })
    .format((cents || 0) / 100);
  if (!s) return `${n} ${c}`;
  return `${s.pre || ''}${n}${s.post || ''}`;
}

// "€1,240 + 8.450 kr" from a per-currency map — the native truth when the
// server couldn't (or shouldn't) add across currencies.
export function formatByCurrency(byCurrency: Record<string, number> | null | undefined, opts?: { exact?: boolean }): string {
  const entries = Object.entries(byCurrency || {}).filter(([, v]) => v !== 0);
  if (entries.length === 0) return formatMoney(0, 'USD', opts);
  return entries.map(([c, v]) => formatMoney(v, c, opts)).join(' + ');
}
